import { Text } from "@medusajs/ui";
import { ExtendedStoreProductVariant } from "types/global";

type LineItemOptionsProps = {
  variant: ExtendedStoreProductVariant | undefined;
  "data-testid"?: string;
  "data-value"?: ExtendedStoreProductVariant;
};

const LineItemOptions = ({ variant, "data-testid": dataTestid, "data-value": dataValue }: LineItemOptionsProps) => {
  const productParameter = variant?.attribute_values?.map((o) => {
    return o?.value || "--";
  });

  return (
    <Text
      data-testid={dataTestid}
      data-value={dataValue}
      className="inline-block text-[13px] text-ui-fg-subtle w-full overflow-hidden text-ellipsis pt-1"
    >
      {productParameter?.join(" | ")}
    </Text>
  );
};

export default LineItemOptions;
